<template>
  <b-modal
    @show="onShow"
    header-class="dlg_header no_border"
    :visible="visible"
    centered
    contentClass="md-confirm-content"
    bodyClass= "confirm-body pt-0"
    footerClass= "confirm-footer"
    :okTitle= "$t('common.ok')"
    :cancelTitle= "$t('common.cancel1')"
    okVariant= "primary md_btn_primary"
    cancelVariant= "secondary md_btn_light"
    @ok="onConfirm"
    @hidden="onCancel"
  >
    <template #modal-header="{close}">
      <div class="popup_title2" style="flex: 1; text-align: center;">{{title}}</div>
    </template>
    <div class="full container" style="overflow-y: auto">
      <div class="align-vertical center" v-if="isChangeGroupName">
        <div class="align-vertical org_group_name_wrapper width_100">
          <span class="btn-label" style="color: black">{{originGroupName}}</span>
        </div>
        <b-img :src="require('../../../assets/image/ic_arrow_strong_black_down.png')" style="margin: 15px auto;" />
      </div>
      <div class="align-horizontal search_box">
        <b-form-input class="search_input" v-model="inputValue" :placeholder="placeholder" :formatter="onlyNumber ? u.formatPhoneNumber : null" />
      </div>
      <div class="contentLabel" style="margin-top: 10px">{{description}}</div>
    </div>
  </b-modal>
</template>

<script>
import Utils from "../../../config/utils"
export default {
  name: "PromptConfirmPopup",
  components: {},
  data() {
    return {
      self: this,
      u: Utils,
      visible: false,
      title: '',
      description: '',
      placeholder: '',
      isChangeGroupName: false,
      originGroupName: '',
      inputValue: '',
      onlyNumber: false,
      onConfirm: () => {},
    }
  },
  props: {
    // visible: {
    //   type: Boolean,
    //   default: false,
    // },
  },
  methods: {
    show (title,  placeholder, description='', onConfirm=()=>{}, isChangeGroupName=false, originGroupName='', onlyNumber=false) {
      Utils.setState(this,{
        title: title,
        description: description,
        placeholder: placeholder,
        isChangeGroupName: isChangeGroupName,
        originGroupName: originGroupName,
        onlyNumber: onlyNumber,
        onConfirm: () => {
          if (this.inputValue){
            Utils.setState(this,{visible: false}, () => {
              onConfirm(this.inputValue);
            });
          }
          else
            Utils.toast(this,this.state.onlyNumber ? this.$t('group.enter_phone_number') : this.$t('group.enter_group_name'));
        },
        visible: true
      })
    },
    onShow() {
      this.inputValue = '';
    },
    onCancel() {
      this.visible=false;
    },
  }
}
</script>

<style scoped lang="scss">
@import "../../../assets/css/vars";

.title-label {font-size: $fs_16; color: $black; text-align: center; font-family: $korean_gd_15_r;}
.contentLabel {
  font-size: $fs_20;
  color: $c_457fff;
  text-align: center;
  font-family: $korean_gd_15_r;
  // include-font-padding :false;
  line-height: 24px;
 }
.control {align-self: center; margin-top: 25px; margin-bottom: 0 }
.btn {
  width: 88px;
  height: 37px;
  border-radius: 3px;
  justify-content: center;
  align-items: center;
  background-color: $c_cacbcd
 }
.btn-label {color: $white; font-size: $fs_20; font-family: $korean_gd_15_r;}
.sale_address {
  color: #0660e2;
  font-size: $fs_10;
  font-family: $korean_gd_17_r;

 }
.search_box {
  border-width: 1px;
  border-radius: 2px;
  border-color: #c4c3c3;
  text-align: center;
  width: 70%;
  margin: auto;
  //margin-top: 15px;
 }
.search_input {
  flex: 1;
  height: 40px;
  color: $black;
  text-align: center;
  font-size: $fs_18;
  font-family: $korean_gd_14_r;  
 }
.org_group_name_wrapper  {
  background-color: $c_cacbcd;
  padding-left: 20px;
  padding-right: 20px;
  height: 50px;
  justify-content: center;
  align-items: center;
  width: 70%;
}

</style>



// WEBPACK FOOTER //
// src/components/controls/popup/PromptConfirmPopup.vue